import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-eliminar-cuenta',
  templateUrl: './eliminar-cuenta.component.html',
  styleUrls: ['./eliminar-cuenta.component.scss']
})
export class EliminarCuentaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
